<template>
  <div class="footer-box-container">
    <div class="main-container">
      <div
        class="footer-box-item wow animate__slideInUp"
        data-wow-duration="800ms"
      >
        <div class="footer-link">
          <div class="link-item">
            <h2>关于我们</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'Group' }">
                  新希望集团
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Estate' }">
                  新希望地产
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Leader' }">
                  管理层
                </router-link>
              </li>
            </ul>
          </div>
          <div class="link-item">
            <h2>产品服务</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'Office' }">
                  办公楼
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Hotel' }">
                  酒店
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Synthesis' }">
                  综合体
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Apartment' }">
                  长租公寓
                </router-link>
              </li>

              <li>
                <router-link tag="p" :to="{ name: 'TouristTown' }">
                  现代文旅
                </router-link>
              </li>

              <li>
                <router-link tag="p" :to="{ name: 'IndustrialPark' }">
                  产业园区
                </router-link>
              </li>
              <li>
                <a href="https://www.newhopeservice.com.cn/" target="_blank"
                  >物业服务</a
                >
              </li>
            </ul>
          </div>
          <div class="link-item">
            <h2>匠星巨著</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'JinYueXi' }">
                  锦悦系
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'JinLinXi' }">
                  锦麟系
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'TianXi' }">
                  天系
                </router-link>
              </li>
            </ul>
            <h2 class="mt15">希望天地</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'Product' }">
                  精致产品
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Active' }">
                  精致活动
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Welfare' }">
                  新希望公益
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Love' }">
                  精准扶贫1+1：希望爱行
                </router-link>
              </li>
            </ul>
          </div>
          <div class="link-item">
            <h2>加入我们</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'Talent' }">
                  人才理念
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Job' }">
                  社会招聘
                </router-link>
              </li>
              <!-- <li>校园招聘</li> -->
              <li>
                <router-link tag="p" :to="{ name: 'Strong' }">
                  培养发展体系
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Plan' }">
                  百千万人才战略
                </router-link>
              </li>
            </ul>
          </div>
          <div class="link-item">
            <h2>新闻中心</h2>
            <ul>
              <li>
                <router-link tag="p" :to="{ name: 'GroupNews' }">
                  集团新闻
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'EstateNews' }">
                  地产动态
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'Media' }">
                  媒体报道
                </router-link>
              </li>
              <li>
                <router-link tag="p" :to="{ name: 'SelfMedia' }">
                  自媒体
                </router-link>
              </li>
            </ul>
          </div>
          <div class="link-item">
            <h2>Newhope网群</h2>
            <ul>
              <li>
                <a href="http://www.newhopegroup.com/" target="_blank"
                  >新希望集团</a
                >
              </li>
              <li>
                <a href="https://www.newhopeagri.com/" target="_blank"
                  >新希望六和</a
                >
              </li>
              <li>
                <a href="https://www.newhopedairy.cn/" target="_blank"
                  >新希望乳业</a
                >
              </li>
              <li>
                <a href="http://www.xingyuan.com/" target="_blank">兴源环境</a>
              </li>
              <li>
                <a href="http://www.caogenzhiben.com/" target="_blank"
                  >草根知本</a
                >
              </li>
              <li>
                <a href="https://xwbank.com/" target="_blank">新网银行</a>
              </li>
              <li>
                <a href="https://www.globalgase.com/" target="_blank"
                  >全球川商总会</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="footer-info">
          <p class="city-link">
            想了解更多优质项目，致电 400-823-5566 垂询或查找在你附近的
            <router-link tag="a" :to="{ name: 'Org' }">城市公司</router-link>
          </p>
          <div class="other-link">
            <a href="http://oa.newhopegroup.com:8090/" target="_blank"
              >员工登陆</a
            >
            <a href="http://xxwpartner.newhope.cn/#/layOut" target="_blank"
              >供应商协同平台</a
            >
            <router-link tag="a" :to="{ name: 'Offence' }"
              >廉洁举报</router-link
            >
            <router-link tag="a" :to="{ name: 'Privacy' }"
              >隐私政策</router-link
            >
            <router-link tag="a" :to="{ name: 'Legal' }">法律声明</router-link>
          </div>
        </div>

        <div class="copy-right">
          <p>
            <span style="display: inline-block; margin-right: 17px"
              >Copyright ©2018-2025 Newhope Inc. 保留所有权利</span
            >
            <span
              ><a
                href="https://beian.miit.gov.cn"
                target="_blank"
                style="color: #888888"
                >蜀ICP备16011090号-2</a
              ></span
            >
          </p>
          <div class="footer-icon">
            <b>社交媒体</b>
            <div class="icon">
              <el-popover
                placement="top"
                title=""
                width="160"
                trigger="hover"
              >
                <div>
                  <img style="width: 160px;" src="../../assets/images/QRcode.png" alt="">
                </div>
                <img slot="reference" src="../../assets/images/icon1.png"
              /></el-popover>
            </div>
            <a
              class="icon"
              href="https://weibo.com/xxwdc?refer_flag=1001030101_&is_hot=1"
              target="_blank"
            >
              <img src="../../assets/images/icon2.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "FooterBox",
};
</script>
<style lang="scss" scoped>
.footer-box-container {
  width: 100%;
  overflow: hidden;
  background-color: #fff;

  .main-container {
    margin-top: 110px;
    width: 100%;
    padding-bottom: 35px;
    background-color: #e3e4e4;
    text-align: center;
    font-size: 12px;
  }

  .footer-box-item {
    width: 950px;
    margin: 0 auto;
    padding-top: 42px;
  }

  .footer-link {
    height: 300px;
    overflow: hidden;
  }

  .link-item {
    width: 119px;
    overflow: hidden;
    font-size: 14px;
    float: left;
    margin-right: 47px;

    &:last-child {
      margin-right: 0;
    }

    h2 {
      display: inline-block !important;
      font-size: 16px !important;
      -webkit-transform: scale(0.8) !important;
      transform: scale(0.8) !important;
      position: relative !important;
      left: -15% !important;
      width: 150% !important;
      color: #3c4346;
      margin-bottom: 7px;
      text-align: left;
      font-weight: 700;
    }

    ul {
      list-style: none;
      padding-inline-start: 0;
      margin: 0;
    }

    li {
      font-size: 12px;
      line-height: 26px;
      text-align: left;
      cursor: pointer;
      display: inline-block !important;
      font-size: 14px !important;
      -webkit-transform: scale(0.8) !important;
      transform: scale(0.8) !important;
      position: relative !important;
      left: -14% !important;
      width: 140% !important;
      color: #888888;

      > a {
        text-decoration: none;
        color: inherit;
        display: inline-block;
        width: 100%;
      }
    }
  }

  .footer-info {
    height: 45px;
    width: 870px;
    margin: 0 auto;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    border-bottom: 1px solid #aeaeae;

    .city-link {
      float: left;
      color: #888888;
      line-height: 48px;
      height: 45px;
      > a {
        color: #008048;
      }
    }

    .other-link {
      display: flex;

      > a {
        text-decoration: none;
        color: #888888;
        cursor: pointer;
        line-height: 45px;
        margin-right: 25px;
        display: inline-block;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }

  .copy-right {
    width: 870px;
    margin: 10px auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #888888;
  }

  .mt15 {
    margin-top: 15px;
  }

  .footer-icon {
    display: flex;
    align-items: center;
    > b {
      display: inline-block;
      font-weight: normal;
    }

    .icon {
      display: inline-block;
      width: 16px;
      margin-left: 16px;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }
}
</style>
